// Lightweight cross-component signal for "the accessible workspace list may
// have changed" (e.g. a background import provisioned new subsidiary
// workspaces). There's no Redux slice for the workspace list — it's fetched
// and cached locally wherever it's rendered — so this lets any component
// trigger a re-fetch elsewhere in the tree without prop drilling.
const target = new EventTarget();
const EVENT_NAME = 'workspaces-changed';

export const emitWorkspacesChanged = (): void => {
  target.dispatchEvent(new Event(EVENT_NAME));
};

export const subscribeWorkspacesChanged = (callback: () => void): (() => void) => {
  target.addEventListener(EVENT_NAME, callback);
  return () => target.removeEventListener(EVENT_NAME, callback);
};
